module.exports = "/_next/static/images/cheese_kiyma_curry-d285e855d39e2c9c48cd4f57df9f12e8.jpg";